import React, { useContext, useEffect, useRef, useState } from "react";
import { httpReauest } from "../../../utils/httpRequest";
import { BASE_URL, CDN_BASE_URL } from "../../../config";
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { FaPlus, FaTrash } from "react-icons/fa";
import Loading from "../Loading";
import ReactQuill from "react-quill";
import { Editor } from "@tinymce/tinymce-react";
import { CiHeart } from "react-icons/ci";
import CustomModal from "../Modal";
import BlogCard from "../card/BlogCard";
import BlogCardImage from "../card/BlogCardImage";
import UploadedModal from "../UploadedModal";
import { AuthContext } from "../../../context/AuthContext";
import { getTiming } from "../../../utils/getTiming";

const EditCommentBlogForm = () => {
  const [brands, setBrands] = useState();
  const [admins, setadmins] = useState();
  const [img, setImg] = useState();
  const [img2, setImg2] = useState();
  const [previewImg, setPreviewImg] = useState();
  const [previewImg2, setPreviewImg2] = useState();
  const [loading, setloading] = useState();
  const [loading2, setloading2] = useState();
  const [selectedBrand, setselectedBrand] = useState();
  const [categorys, setCategorys] = useState();
  const [show, setshow] = useState();
  const [active, setactive] = useState();
  const [file, setfile] = useState();
  const [text, settext] = useState();
  const [blogCategory, setblogCategory] = useState([]);
  const [comments, setcomments] = useState([]);

  async function getData() {
    await httpReauest("GET", "/category", {}, {}).then(({ data }) => {
      setCategorys(data?.data);
    });

    await httpReauest("GET", "/blogcategory", {}, {}).then(({ data }) => {
      setblogCategory(data?.data);
    });
  }

  useEffect(() => {
    stayLogin();
    getData();
  }, []);

  async function stayLogin() {
    await httpReauest("GET", "/blog", {}, {}).then(({ data }) => {
      setBrands(data?.data);
    });

    await httpReauest("GET", "/admin/getall?main=true", {}, {}).then(
      ({ data }) => {
        setadmins(data?.data);
      }
    );
  }

  async function hadnleChangeAdmin(params) {
    if (params === "newst") {
      await httpReauest("GET", "/blog?newst=true", {}, {}).then(({ data }) => {
        setBrands(data?.data);
      });
    } else if (params === "oldest") {
      await httpReauest("GET", "/blog?oldest=true", {}, {}).then(({ data }) => {
        setBrands(data?.data);
      });
    } else {
      const value = params.target.value;
      await httpReauest("GET", `/blog?author=${value}`, {}, {}).then(
        ({ data }) => {
          setBrands(data?.data);
        }
      );
    }
  }

  const VALUE_SIGN_VALIDATION = () => {
    return Yup.object({
      name: Yup.string().required("الزامی است"),
      url: Yup.string().required("الزامی است"),
      category: Yup.string().required("الزامی است"),
    });
  };

  const { user, setUser } = useContext(AuthContext);

  const formik = useFormik({
    initialValues: {
      name: "",
      meta_keywords: "",
      meta_desc: "",
      content: "",
      desc: "",
      related: "",
      url: "",
      category: "",
    },
    validationSchema: VALUE_SIGN_VALIDATION,
    onSubmit: async (values) => {
      setloading(true);
      const formdata = new FormData();
      if (img) {
        formdata.append("logo", img, img?.name);
      }
      if (img2) {
        formdata.append("cover", img2, img2?.name);
      }
      formdata.append("name", values.name);
      formdata.append("desc", values.desc);
      formdata.append("meta_desc", values.meta_desc);
      formdata.append("meta_keywords", values.meta_keywords);
      formdata.append("related", values.related);
      formdata.append("url", values.url);
      formdata.append("category", values.category);
      formdata.append("content", editorRef.current.getContent());

      await fetch(BASE_URL + "/blog/" + selectedBrand?._id, {
        method: "PUT",
        body: formdata,
        headers: { "x-access-token": user.token },
      })
        .then(async (dat) => {
          if (dat?.status == 201) {
            toast.success("بلاگ تغییر یافت");
            setloading(false);
            setselectedBrand("");
            formik.resetForm();
            setImg(null);
            setImg2(null);
            setPreviewImg(null);
            setPreviewImg2(null);
          } else {
            const message = await dat.json();
            setloading(false);
            toast.error(message.message);
          }
        })
        .catch((err) => {
          setloading(false);
          toast.error(err.response?.data?.message);
        });
    },
  });

  async function handleDelete(id) {
    await fetch(BASE_URL + "/blog/comment/" + id, {
      method: "DELETE",
      headers: { "x-access-token": user.token },
    })
      .then((dat) => {
        if (dat?.status == 201) {
          toast.success("کامنت حذف شد");
        }
      })
      .catch((err) => {
        toast.error(err.response?.data?.message);
      });
  }

  async function handleUpload() {
    if (!file) {
      return toast.error("فایلی انتخاب نشده است");
    }

    const formdata = new FormData();
    formdata.append("file", file, file.name);

    const res = await fetch(BASE_URL + "/blog/upload", {
      method: "POST",
      body: formdata,
      headers: { "x-access-token": user.token },
    });

    const data = await res.json();

    settext(data.data);
    setfile(null);
  }

  async function handleChangeSetBlog(e) {
    const newBrand = await brands.find((asd) => asd?._id == e);
    setloading2(true);
    await httpReauest("GET", "/blog/comment/" + newBrand._id, {}, {}).then(
      ({ data }) => {
        setselectedBrand(newBrand);
        setcomments(data.data);
      }
    );
    setloading2(false);
  }

  console.log(comments);
  function handleImg(e) {
    const fils = e.target.files[0];
    if (fils.size > 2031517) {
      toast.error("حجم فایل باید کمتر از دو مگابایت باشد");
    } else {
      setImg(fils);
      setPreviwImage(fils);
    }
  }
  function handleImg2(e) {
    const fils = e.target.files[0];
    if (fils.size > 2031517) {
      toast.error("حجم فایل باید کمتر از دو مگابایت باشد");
    } else {
      setImg2(fils);
      setPreviwImage2(fils);
    }
  }

  async function setPreviwImage(imgInput) {
    const reader = new FileReader();
    reader.onloadend = function () {
      setPreviewImg(reader.result);
    };
    reader.readAsDataURL(imgInput);
  }

  async function setPreviwImage2(imgInput) {
    const reader = new FileReader();
    reader.onloadend = function () {
      setPreviewImg2(reader.result);
    };
    reader.readAsDataURL(imgInput);
  }

  const editorRef = useRef(null);

  if (loading2) {
    return <Loading />;
  }

  return (
    <div>
      <h2 className="text-[20px] mb-8 font-bold p-3">مدیریت نظرات بلاگ</h2>
      <form
        onSubmit={formik.handleSubmit}
        className="grid grid-cols-1 lg:grid-cols-3 2xl:grid-cols-4 gap-6"
      >
        {!selectedBrand && (
          <span className="col-span-full">
            <h2 className="text-[18px] font-bold mb-2">فیلتر:</h2>
            <div className="flex gap-5">
              <span className="flex gap-2 items-center">
                <label>قدیمی ترین</label>
                <input
                  type="checkbox"
                  onClick={() => {
                    hadnleChangeAdmin("newst");
                    setactive("1");
                  }}
                  checked={active === "1"}
                />
              </span>
              <span className="flex gap-2 items-center">
                <label>جدید ترین</label>
                <input
                  onClick={() => {
                    hadnleChangeAdmin("oldest");
                    setactive("2");
                  }}
                  checked={active === "2"}
                  type="checkbox"
                />
              </span>
              <span className="flex gap-2 items-center">
                <label>نویسنده</label>
                <select
                  id="author"
                  name="author"
                  onChange={hadnleChangeAdmin}
                  className={` w-full min-w-[130px] form-brand h-[48px]`}
                >
                  {admins?.map((e) => {
                    return <option value={e.name}>{e.name}</option>;
                  })}
                </select>
              </span>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5 mt-5">
              {brands?.map((e) => {
                return (
                  <BlogCardImage
                    handleChangeSetBlog={handleChangeSetBlog}
                    data={e}
                  />
                );
              })}
            </div>
          </span>
        )}

        {selectedBrand && (
          <>
            <button
              onClick={() => setselectedBrand("")}
              className="btn-brand mb-10"
            >
              انتخاب بلاگ جدید
            </button>

            <span className="col-span-full flex flex-col gap-3">
              {comments?.map((e) => {
                const now = new Date();
                const newTime =
                  now.getTime() - new Date(e?.createdAt).getTime();
                const hour = newTime / 86400000;
                return (
                  <div className="border-dashed border-[#8E9192] py-4 border-t px-1">
                    <div className="flex w-full gap-4 items-center">
                      <span>
                        <img
                          src="https://i0.wp.com/digitalhealthskills.com/wp-content/uploads/2022/11/3da39-no-user-image-icon-27.png"
                          className="w-[63px] h-[63px] rounded-full"
                          alt="UserImage"
                        />
                      </span>
                      <span>
                        <h4 className="text-[18px] font-extrabold">
                          {e?.name}
                        </h4>
                        <p className=" text-[14px] mt-1 ">{getTiming(hour)}</p>
                      </span>
                      <span>
                        <FaTrash
                          onClick={() => handleDelete(e._id)}
                          color="red"
                          size={26}
                          className="cursor-pointer"
                        />
                      </span>
                    </div>
                    <p className="text-[14px] leading-6 text-justify mt-4 text-[#393C3D]">
                      {e?.content}
                    </p>
                  </div>
                );
              })}
            </span>
          </>
        )}
      </form>
    </div>
  );
};

export default EditCommentBlogForm;
